"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Mon Jun 11 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * FamilyConverter.
 *
 * @author JMe
 */


var FamilyConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(FamilyConverter, _DataObjectConverter_);

  function FamilyConverter() {
    _classCallCheck(this, FamilyConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(FamilyConverter).apply(this, arguments));
  }

  return FamilyConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.FamilyConverter = FamilyConverter;